export default {
    files: [],
    selectedFiles: [],
    pagination: {},
    mementoSelectedFiles: []
}